module.exports = __webpack_public_path__ + "img/farming_9.2a68cc33.png";